/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React from "react"
import { useTheme } from "@cd2/theme"
import { List } from "@cd2/components"
import { CGButton } from "./CGButton"
import { IComponentProp, IComponentProps } from "../types/utils"
import { Flex } from "./Flex"

interface IMultiButtonProps {
  buttons: (
    | (IComponentProps<typeof CGButton> & {
        Wrapper?: ({ children }: { children: React.ReactNode }) => any
      })
    | (() => React.ReactNode)
  )[]
  asGroup?: boolean | "vertical"
  buttonColor?: string | { color: string; hover: string }
  extendTheme?: any
  justifyContent?: IComponentProp<typeof List, "justifyContent">
  allowWrap?: boolean
}
export function MultiButton({
  buttons,
  asGroup,
  buttonColor,
  extendTheme,
  justifyContent,
  allowWrap,
}: IMultiButtonProps) {
  const { borderRadius } = useTheme()

  return (
    <Flex
      gap={asGroup ? 0 : 6}
      alignItems="start"
      direction={asGroup !== "vertical" ? "row" : "column"}
      justifyContent={justifyContent as any}
      wrap={allowWrap}
    >
      {buttons.map((button, i) => {
        if (typeof button === "function") {
          return <div key={i}>{button()}</div>
        } else {
          const renderButton = (
            <CGButton
              buttonColor={buttonColor}
              {...button}
              children={button.children}
              extendTheme={{
                borderRadius: asGroup
                  ? asGroup === "vertical"
                    ? {
                        topLeft: i === 0 ? borderRadius / 2 : 0,
                        topRight: i === 0 ? borderRadius / 2 : 0,
                        bottomRight: i === buttons.length - 1 ? borderRadius / 2 : 0,
                        bottomLeft: i === buttons.length - 1 ? borderRadius / 2 : 0,
                      }
                    : {
                        topLeft: i === 0 ? borderRadius : 0,
                        topRight: i === buttons.length - 1 ? borderRadius : 0,
                        bottomRight: i === buttons.length - 1 ? borderRadius : 0,
                        bottomLeft: i === 0 ? borderRadius : 0,
                      }
                  : undefined,
                ...extendTheme,
                ...button.extendTheme,
              }}
              buttonProps={{
                ...button.buttonProps,
                ...(asGroup
                  ? asGroup === "vertical"
                    ? {
                        block: true,
                        css:
                          i !== 0
                            ? css`
                                border-top: none;
                              `
                            : ``,
                      }
                    : {
                        css:
                          i !== 0
                            ? css`
                                border-left: none;
                              `
                            : "",
                      }
                  : undefined),
              }}
            />
          )
          if (button.Wrapper) {
            const ButtonWrapper = button.Wrapper
            return (
              <div key={i}>
                <ButtonWrapper>{renderButton}</ButtonWrapper>
              </div>
            )
          }
          return <div key={i}>{renderButton}</div>
        }
      })}
    </Flex>
  )
}
